import { useEffect, useState } from 'react';
import ListAvailablesForms from './components/Form';
import Download from './components/Download'
import { Routes, Route } from 'react-router-dom';
import './styles/_global.scss'
import Metaform from './components/Metaform';
import Admin from './components/admin/Admin';
import Login from './components/Login';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { Database, getSessionStatus, removeCacheAndLogOut } from './services/serviceDB';

export default function App() {
  const [isConnected, setIsConnected] = useState(false)
  const [roles, setRoles] = useState<any>([])
  const [isLoaded, setIsLoaded] = useState(false)
  const [isOnline, setIsOnline] = useState(true)


  // Callback for getSessionStatus
  const childToParent = (childdata) => {
    setIsConnected(childdata.isConnected)
    // The app doesn't want to disconnect if we are on the root, so if you're logged you're automatically redirected to forms
    if (childdata.isConnected && window.location.pathname === '/') {window.location.href = "/formulaires"} 
    setRoles(childdata.roles)
    setIsOnline(childdata.isOnline)
    highlightCurrentLocation()
    setIsLoaded(true)
  }


  const disconnectUser = async () => {
    await removeCacheAndLogOut().finally(() => setIsConnected(false))
  }


  const highlightCurrentLocation = () => {
    let pathname = window.location.pathname.substring(1)
    var x = document.getElementById("nav_"+pathname)
    if (x) {x.className = "navbar-highlight"}
  }

  
  // adapt to small display
  const displayResponsiveNav = () => {
    var x = document.getElementById("navbar")
    if (x?.className === "navbar") {
      x.className += " responsive";
    } else {
      if (x) {x.className = "navbar";}
    }
  }


  useEffect(() => {
    if (isOnline && isConnected) {
      let ResultDB = new Database("results")
      ResultDB.local_database.info().then(function (result) {
        if(result.doc_count === 0) {
        } else {
          ResultDB.pushToRemote()
        }
      });
    }
    getSessionStatus({ childToParent })
  }, [isConnected])


  // RENDERING
if (isConnected && isLoaded) {
    return (
      <>
        <ul className="navbar" id='navbar'>

          <li id='nav_formulaires'><a href="formulaires">Formulaires</a></li>
          {isOnline ? (<li id='nav_telechargement'><a href="telechargement">Téléchargement</a></li>) : null}

          {/* Display Metaform and Admin if online and admin */}
          {["website_admin", "_admin"].some(role => roles.includes(role)) && isOnline
            ? (
              <>
                <li id='nav_gestion_formulaire'><a href="gestion_formulaire">Gestion des formulaires</a></li>
                {roles.includes("_admin") ?
                <li id='nav_administration'><a href="administration">Administration</a></li>  : null}
              </>
            )
            : null}

          {/* Disable disconnexion if offline */}
          {isOnline ? (<li className='nav-disconnect'><a href="/" onClick={disconnectUser}><b>Se déconnecter</b></a></li>) : null }
          
          {/* Responsive design */}
          <li className='icon' onClick={displayResponsiveNav}><FontAwesomeIcon icon={faBars} size="2x"/></li>
        </ul>
        {/* Display offline notice */}
        {isOnline ? null : (<div className='offline-notif'><b>Vous n'êtes pas connecté à internet</b></div>) }

        <Routes>
          <Route path="/formulaires" element={<ListAvailablesForms />} />
          {isOnline  ? (<Route path="/telechargement" element={<Download />} />) : null}

          {/* Routes exist only if admin and online  */}
          {["website_admin", "_admin"].some(role => roles.includes(role)) && isOnline
            ? (
              <>
                <Route path="/gestion_formulaire" element={<Metaform />}></Route>
                {roles.includes("_admin") ?
                (<Route path="/administration" element={<Admin />}></Route>) : null}
              </>
            )
            : null}
        </Routes>
      </>
    );
  } 
else if (isLoaded && !isConnected) {
    return <Login></Login>
  }
else {
  return (<></>)
}
};
